var _ellipse, _path, _path2, _path3, _path4, _g, _path5, _path6, _ellipse2, _ellipse3, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.867,
    cy: 103.741,
    rx: 31.233,
    ry: 7.28769,
    fill: "url(#paint0_linear_6873_126895)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9111 61.732C73.2976 60.3681 84.295 65.3554 93.1165 85.8465C80.9765 97.2783 64.7934 103.421 48.1255 102.924L46.6005 102.878C40.1048 81.5355 45.4348 71.0443 57.9111 61.732Z",
    fill: "#E7F1FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2026 65.2591C71.682 55.9557 77.0179 45.4805 70.5384 24.1821L24.0224 41.2137C32.8277 61.6605 43.6661 66.2136 59.2026 65.2591Z",
    fill: "#E7F1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9111 61.732C73.2976 60.3681 84.295 65.3554 93.1165 85.8465C80.9765 97.2783 64.7934 103.421 48.1255 102.924L46.6005 102.878C40.1048 81.5355 45.4348 71.0443 57.9111 61.732Z",
    fill: "#E7F1FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6873_126895",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 50,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2026 65.2593C71.6821 55.9558 77.018 45.4806 70.5385 24.1822L24.0224 41.2139C32.8277 61.6607 43.6662 66.2137 59.2026 65.2593Z",
    fill: "#E7F1FD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6873_126895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.0769 56.1456C60.6523 41.0364 72.7994 37.2725 71.6098 27.0242L74.9814 25.4761L77.857 51.4836C77.857 51.4836 69.5016 71.2548 65.0769 56.1456Z",
    fill: "#2538BF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4319 75.2751C77.7046 75.6883 84.089 77.8553 89.2002 85.0145C89.6957 85.7084 89.5015 86.6685 88.7987 87.1513C77.6798 94.7906 64.8344 99.5424 51.4207 100.978L50.9467 101.029C50.0492 101.125 49.2431 100.427 49.1647 99.5277C46.9727 74.3826 49.2409 77.2449 54.7677 77.6223C60.0317 77.9817 65.164 74.9759 70.4319 75.2751Z",
    fill: "#FFBF39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2185 37.9905C62.0636 33.2874 71.5841 27.0371 70.4831 24.0303C70.4818 24.0268 70.4805 24.0232 70.4792 24.0197L69.4097 21.0987L65.7536 22.4374C61.0672 22.4395 53.4658 24.0868 45.2316 27.1017C36.9975 30.1166 30.1295 33.7672 26.5498 36.7917L22.8936 38.1304L23.967 41.062L23.9671 41.062C25.0681 44.0688 36.3735 42.6937 49.2185 37.9905Z",
    fill: "#2538BF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.1452,
    cy: 29.5971,
    rx: 24.768,
    ry: 5.7792,
    transform: "rotate(-20.11 46.1452 29.5971)",
    fill: "#648CFE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0154,
    cy: 78.6407,
    rx: 16.4948,
    ry: 3.8488,
    transform: "rotate(1.17086 66.0154 78.6407)",
    fill: "#C28030"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3881 98.5394C84.2288 93.8378 93.7472 87.5903 92.6538 84.5822L93.7232 87.5028L93.7261 87.5109C94.8271 90.5178 85.3066 96.768 72.4616 101.471C59.6165 106.174 48.311 107.549 47.2101 104.543L47.2101 104.543L47.2101 104.543L46.1367 101.611L46.1367 101.611C47.2379 104.618 58.5432 103.243 71.3881 98.5394Z",
    fill: "#2538BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1038 41.7113C8.85076 37.8943 9.8517 34.2985 11.2873 31.6815C11.5865 31.1361 12.1264 31.4903 11.9001 32.0698C10.228 36.352 10.5339 39.5638 10.7046 41.5906C10.7482 42.109 10.2661 42.2056 10.1038 41.7113Z",
    fill: "#0E72ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2819 62.8991C94.5835 59.6097 92.9652 57.972 91.1648 57.0525C90.6108 56.7696 90.2749 57.5757 90.7785 57.9409C93.6769 60.0429 94.357 61.7794 94.814 63.0577C94.9892 63.5476 95.3899 63.408 95.2819 62.8991Z",
    fill: "#0E72ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3621 44.367C13.5227 38.7639 14.992 33.4857 17.0993 29.6442C17.5385 28.8436 18.331 29.3636 17.9989 30.2142C15.5444 36.5001 15.9934 41.2147 16.244 44.1899C16.308 44.9508 15.6003 45.0926 15.3621 44.367Z",
    fill: "#0E72ED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.247 94.0353C33.8612 88.6422 34.8 83.2443 36.5162 79.2129C36.8739 78.3727 37.714 78.8115 37.4678 79.6909C35.6485 86.1891 36.5626 90.8359 37.1069 93.7716C37.2461 94.5225 36.5559 94.7337 36.247 94.0353Z",
    fill: "#0E72ED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1544 69.6897C92.5275 64.4515 88.3124 61.5217 84.4107 59.8572C83.5708 59.4989 83.1862 60.4656 83.9743 60.9269C89.4307 64.1203 90.2136 65.7419 93.0621 70.1377C93.5018 70.8162 94.3942 70.4618 94.1544 69.6897Z",
    fill: "#0E72ED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8405 32.619L33.4351 29.3093L52.11 20.9506C53.9098 21.9211 58.1206 23.8595 60.5655 23.8498C63.0104 23.8402 64.137 23.1292 64.3947 22.7748C65.0309 22.8312 65.6654 23.374 63.1142 25.0941C60.563 26.8141 55.9794 24.1034 54.0064 22.5331L53.5594 30.131C53.5594 30.131 52.0375 28.4894 50.7449 28.6935C47.5317 29.2008 41.3349 34.6485 41.3349 34.6485L42.0235 30.0704C42.0235 30.0704 39.14 31.5127 37.1555 32.0151C36.9381 30.6381 31.8405 32.619 31.8405 32.619Z",
    fill: "#2538BF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3128 24.4365C55.1733 22.5791 53.2805 19.9454 53.2805 19.9454C53.2805 19.9454 63.0558 16.863 63.3184 12.566C63.357 11.933 62.2992 10.7706 62.1927 11.3957C61.4601 15.6953 52.4325 19.7909 52.4325 19.7909C52.4325 19.7909 52.0701 16.621 50.771 15.0388C49.4423 14.0725 45.8796 13.0346 45.8796 13.0346C45.8796 13.0346 47.0011 14.4856 47.3284 15.5824C45.0092 14.3019 35.1298 17.7435 35.1298 17.7435C35.1298 17.7435 42.3025 19.637 40.1943 19.6135C38.3171 19.5926 32.7016 24.009 32.7016 24.009C32.7016 24.009 34.0106 24.5009 34.8555 24.7988C33.5093 27.8789 31.1336 29.22 31.1336 29.22C31.1336 29.22 35.6596 29.8918 37.3304 28.2418C37.5961 28.6647 37.014 29.6779 37.014 29.6779C37.014 29.6779 39.8923 28.0801 44.4451 27.1186C42.7604 27.8353 42.6896 30.8989 42.6896 30.8989C42.6896 30.8989 50.336 25.6928 51.9037 26.1838C53.2381 26.1952 52.8002 27.8912 52.8002 27.8912C52.8002 27.8912 55.4362 26.0794 55.3128 24.4365Z",
    fill: "#FFBF39"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2064 25.2628C39.4704 24.3599 41.4414 23.0966 43.5702 21.9883M52.3877 19.7306C50.9763 19.5183 48.369 19.8745 46.4187 20.6619M46.4187 20.6619C46.3629 19.8119 45.5942 18.1215 42.9658 18.1601M46.4187 20.6619C45.4698 21.0451 44.5047 21.5017 43.5702 21.9883M48.2203 20.1534C48.4296 20.9828 48.6068 23.1973 47.6404 25.4199M43.5702 21.9883C42.7083 23.4824 40.8469 26.4924 40.2961 26.5794M41.1659 23.1489C40.3966 22.7465 38.5491 22.0697 37.3125 22.5811",
    stroke: "#DC7929",
    strokeWidth: 0.464704,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0178 51.2598C91.7867 49.5243 92.1782 46.4488 92.1782 46.4488C92.1782 46.4488 87.1181 46.5783 86.3351 42.7754C86.3827 42.4035 86.7936 41.9198 87.0604 41.9246C88.0432 45.5594 92.5138 46.0011 92.5138 46.0011C92.5138 46.0011 91.6769 44.3169 92.4761 41.0878C92.8888 39.7294 94.2383 37.496 94.2383 37.496C94.2383 37.496 93.9892 39.2189 94.0218 40.3325C94.8057 38.33 99.5355 37.8696 99.5355 37.8696C99.5355 37.8696 96.788 42.1883 97.6789 41.4025C98.4721 40.7028 101.545 42.6729 101.545 42.6729C101.545 42.6729 101.067 43.5938 100.755 44.1704C101.807 46.4764 103.025 46.8315 103.025 46.8315C103.025 46.8315 101.209 49.082 100.243 48.1912C100.196 48.6711 100.601 49.3792 100.601 49.3792C100.601 49.3792 99.1303 48.9735 97.0482 49.7521C97.8751 49.7914 98.3839 52.5448 98.3839 52.5448C98.3839 52.5448 94.3258 50.5948 93.7374 51.6087C93.173 52.1029 93.6238 53.4826 93.6238 53.4826C93.6238 53.4826 92.2222 52.7949 92.0178 51.2598Z",
    fill: "#DC7929"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6272 46.0377C93.0365 45.8501 93.6559 45.6227 94.3471 45.4623M100.17 46.5557C98.5105 45.3359 96.8275 45.3115 96.3401 45.2736M94.3471 45.4623C94.1765 44.2178 94.2858 41.4635 96.088 40.4027M94.3471 45.4623C94.9865 45.314 95.6874 45.2229 96.3401 45.2736M93.8152 45.8381C93.7257 46.8399 93.8283 49.0165 94.9553 49.7086M96.2886 45.5769C96.2437 46.1403 96.446 47.3795 97.6146 47.8296M96.3401 45.2736C96.5207 44.5261 97.316 43.0435 99.0519 43.0928",
    stroke: "#FFBF39",
    strokeWidth: 0.434153,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6873_126895",
    x1: 49.5806,
    y1: 107.65,
    x2: 107.332,
    y2: 103.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2538BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2538BF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIllustration);
export default __webpack_public_path__ + "static/media/hourglass-illustration.e9f951cc1a4cf087bfccdeff4ac78449.svg";
export { ForwardRef as ReactComponent };